interface SectionHeaderProps {
  title?: string
  subtitle?: string
  description?: string
  className?: string
  subTitleStyle?: string
  descriptionStyle?: string
  titleStyle?: string
}

const SectionHeader = ({
  title,
  subtitle,
  description,
  className,
  subTitleStyle,
  descriptionStyle,
  titleStyle,

}: SectionHeaderProps) => {
  return (
    <div className={`flex flex-col ${className} max-w-full`}>
      <h2 className={`text-[#0853E4] font-normal text-base md:text-xl leading-tight] ${titleStyle}` }>
        {title}
      </h2>
      <h1 className={`font-bold  ${subTitleStyle}`}>{subtitle}</h1>
      <p className={`text-[#6C757D] lg:leading-[28px] ${descriptionStyle}`}>
        {description}
      </p>
    </div>
  )
}

export default SectionHeader
